import { useParams } from 'react-router';

import {
  AppraisalsRoutePaths,
  useStartAppraisalMutation,
} from '@app-velocity/modules/appraisals';

import { NewReviewContext } from '../context/NewReviewContext';
import { NewReview } from '../NewReview';

export const NewAuthReview = () => {
  const { teamId, workspaceId } = useParams<{
    teamId: string;
    workspaceId: string;
  }>();

  const { mutateAsync: startAppraisal } =
    useStartAppraisalMutation(workspaceId);

  if (!workspaceId || !teamId) return null;

  return (
    <NewReviewContext.Provider
      value={{
        mode: 'authorized',
        workspaceId,
        teamId,
        onReviewStart: startAppraisal,
        goToAppraisalDetails: AppraisalsRoutePaths.appraisalDetails,
      }}
    >
      <NewReview />
    </NewReviewContext.Provider>
  );
};
